import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-estonia',
    templateUrl: './estonia.component.html',
    styleUrls: ['./estonia.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EstoniaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
